import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@cpe/environments/environment';

@Injectable({ providedIn: 'root' })
export class FileService {
  constructor(private readonly http: HttpClient) {}

  downloadPdf(fileUrl: string) {
    return this.http.get(fileUrl, { responseType: 'blob' });
  }
}
